'use strict';

var _ = require('underscore'),
    React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ServiceTypes = require('../constants/ServiceTypes'),
    getShareServiceTitle = require('../utils/getShareServiceTitle'),
    { PropTypes } = React;

require('./Share.less');

var iconSizes = {
  'small': 'xsmall',
  'medium': 'small',
  'large': 'medium'
};

var Share = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    onShareClick: PropTypes.func.isRequired,
    services: PropTypes.arrayOf(
      PropTypes.oneOf([
        ServiceTypes.FACEBOOK,
        ServiceTypes.TWITTER,
        ServiceTypes.GOOGLE,
        ServiceTypes.PINTEREST,
        ServiceTypes.TUMBLR
      ]).isRequired
    ).isRequired,
    color: PropTypes.oneOf(['black', 'dark', 'light', 'gray']).isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
    context: PropTypes.string,
    vertical: PropTypes.bool,
    plainIcon: PropTypes.bool,
    showServiceName: PropTypes.bool,
    showShareWordPrefix: PropTypes.bool
  },

  className: 'Share',

  getDefaultProps: function () {
    return {
      color: 'dark',
      services: [
        ServiceTypes.FACEBOOK,
        ServiceTypes.TWITTER,
        ServiceTypes.GOOGLE,
        ServiceTypes.PINTEREST,
        ServiceTypes.TUMBLR
      ]
    };
  },

  getCSSModifiers: function () {
    return [
      this.props.size
    ];
  },

  render: function () {
    return (
      <div className={this.getClassName()}>
        <BtnGroup vertical={this.props.vertical}>
          {_.map(this.props.services, this.props.plainIcon ?
                                      this.renderServiceIcon :
                                      this.renderServiceButton)}
          {this.props.children}
        </BtnGroup>
      </div>
    );
  },

  renderServiceButton: function (service) {
    var buttonProps = _.pick(this.props, ['color', 'size', 'context', 'overlay']),
        iconSize = this.props.iconSize || iconSizes[this.props.size],
        serviceTitle = getShareServiceTitle(service),
        label;

    if (this.props.showServiceName) {
      label = serviceTitle;

      if (this.props.showShareWordPrefix) {
        label = 'Share on ' + label;
      }
    }

    return (
      <Button key={service}
              onClick={_.partial(this.handleShareClick, service)}
              round={!label}
              {...buttonProps}>
        <Icon name={service.toLowerCase()}
              size={iconSize} />
        {label}
      </Button>
    );
  },

  renderServiceIcon: function (service) {
    var iconSize = this.props.iconSize || iconSizes[this.props.size];

    return (
      <Icon key={service}
            name={service.toLowerCase()}
            size={iconSize}
            context='share'
            onClick={_.partial(this.handleShareClick, service)} />
    );
  },

  handleShareClick: function (service, e) {
    e.stopPropagation();
    this.props.onShareClick(service);
  }
});

module.exports = Share;



/** WEBPACK FOOTER **
 ** ./molecules/Share.jsx
 **/